<template>
    <table class="table table-list">
        <tr class="table-list-tr">
            <td rowspan="2">
                <figure v-if="item.component">
                    <router-link class="basketImg pointer" tag="span" :to="'/product/' + item.component.id + '?refere=basket'">
                        <img :src="getImgPath(item.component.figures.small)" alt="" />
                    </router-link>
                </figure>
                <figure v-if="item.component === null">
                    <router-link class="basketImg pointer" tag="span" :to="'/plano/' + item.planoInfo.id + '?refere=basket'">
                        <img src="../../../static/assets/plano.png" class="ac-c" />
                    </router-link>
                </figure>
            </td>
            <td>
                <h3 v-if="item.component">
                    <router-link class="pointer" tag="span" :to="'/product/' + item.component.id + '?refere=basket'">
                        {{ item.component.terms.name[$t("trad")].value }}
                    </router-link>
                </h3>
                <h3 v-if="item.component === null">
                    <router-link class="pointer" tag="span" :to="'/plano/' + item.planoInfo.id + '?refere=basket'">
                        {{ item.planoInfo.name }}
                    </router-link>
                </h3>
                <p class="typeRef">
                    <span>{{ item.component ? item.component.type : item.planoInfo.type.name }}</span>
                    <span v-if="item.component && item.component.infosArticle.client_ref1">
                        {{ item.component.infosArticle.client_ref1.componentProperty.value }}</span
                    >
                    <span v-if="item.component && item.component.infosArticle.diam_ref1">
                        {{ item.component.infosArticle.diam_ref1.componentProperty.value }}
                    </span>
                </p>
            </td>
            <td class="price">
                <span>{{ displayRealPrice(item.unitPrice, getBasket.priceShown) | CurrencyCustomPipe("en-US", getBasket.currency.shortName) }}</span>
            </td>
            <td>
                <input
                    v-if="item.component"
                    v-model.number="item.quantity"
                    type="number"
                    min="1"
                    class="input-number"
                    v-bind:class="{ error: item.quantity <= 0 }"
                    @change="changeQuantity();"
                />
            </td>
            <td v-show="showUnit"><span v-if="item.component">X</span></td>
            <td v-show="showUnit">
                <input
                    v-model.number="item.unit"
                    type="number"
                    min="1"
                    class="input-number"
                    v-bind:class="{ error: item.unit <= 0 }"
                    @change="changeQuantity();"
                />
            </td>
        </tr>
        <tr>
            <td colspan="6">
                <div class="basket-footer">
                    <div class="basket-footer-remove" @click="deleteBasketItem();">{{ $t("basket.removeLink") }}</div>
                    <div class="basket-footer-author" v-if="getBasket.createdBy">
                        {{ $t("basket.userBasket") }} {{ getBasket.createdBy.firstname }} {{ getBasket.createdBy.lastname }}
                        {{ $t("basket.dateBasket").replace("{date}", item.modifiedDate) }}
                    </div>
                </div>
            </td>
        </tr>
    </table>
</template>

<script>
import Globals from "../globals.js";
import { mapGetters, mapActions } from "vuex";
import cacheService from "@/services/cache";

export default {
    name: "BasketListItem",
    data() {
        return {
            currentLang: cacheService.getUserLang()
        };
    },
    props: ["item", "showUnit"],
    computed: {
        ...mapGetters("basket/details", {
            getBasket: "getBasket"
        })
    },
    methods: {
        ...mapActions("basket/details", {
            updateBasket: "updateBasket",
            deleteBasketItemAction: "deleteBasketItemAction"
        }),
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        },
        changeQuantity() {
            let objDetailItem = {
                id: this.item.id,
                quantity: this.item.quantity,
                nbPlano: this.item.unit
            };
            this.updateBasket(objDetailItem);
        },
        deleteBasketItem() {
            this.$swal({
                title: this.$t("basket.warning"),
                text: this.$t("basket.alertRemove").replace(
                    "{item}",
                    this.item.component ? this.item.component.terms.name[this.currentLang].value : this.item.planoInfo.name
                ),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: this.$t("actions.remove"),
                cancelButtonText: this.$t("actions.cancel"),
                closeOnConfirm: true
            }).then(() => {
                this.deleteBasketItemAction(this.item.id);
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.table-list {
    width: 100%;
    td {
        border: none;
    }
    border-bottom: 2px solid #dee2e6;
    &-tr {
        transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
        border-bottom: 1px solid #e5e5e5;
        background-color: #ffffff;
        h3 {
            color: $color2;
        }
        td {
            border: none;
            padding: 1.1rem;
            text-align: left;
            color: #6f6f6f;
            & .btn-list {
                color: #ffffff;
                background: #005f7f;
                padding: 5px 20px;
                text-decoration: none;
                &:hover {
                    background: #0085b2;
                }
            }
            &.price {
                font-weight: bold;
            }
            .input-number {
                width: 70px;
                text-align: center;
                &.error {
                    border: 1px solid red;
                }
            }
            &:first-child {
                width: 130px;
                @media only screen and (max-width: 767px) {
                    width: 90px;
                    padding: 0;
                }
            }
            &:last-child {
                width: 100px;
                @media only screen and (max-width: 767px) {
                    width: 70px;
                }
            }
            &:nth-child(2) {
                width: 50%;
                @media only screen and (max-width: 767px) {
                    width: auto;
                }
            }
            &:nth-child(3) {
                width: 120px;
                @media only screen and (max-width: 767px) {
                    width: auto;
                }
            }
            &:nth-child(4) {
                width: 100px;
                @media only screen and (max-width: 767px) {
                    width: auto;
                }
            }
            &:nth-child(5) {
                width: 20px;
                font-size: 12px;
                padding-top: 15px;
                @media only screen and (max-width: 767px) {
                    width: auto;
                }
            }
            .typeRef {
                margin: 0;
                span {
                    display: block;
                    font-size: 11px;
                    text-transform: uppercase;
                }
            }
            h3 {
                font-size: 18px;
                font-family: "oswald-regular", sans-serif;
                margin: 0 0 5px 0;
            }
            figure {
                img {
                    max-width: 110px;
                    @media only screen and (max-width: 767px) {
                        max-width: 90px;
                    }
                }
            }
            & a {
                color: #6f6f6f;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    & .basket-footer {
        & div {
            display: inline-block;
            font-size: 13px;
        }
        &-remove {
            cursor: pointer;
            text-transform: uppercase;
            color: $color2;
        }
        &-author {
            float: right;
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasketListItem.vue?fcbbfe24